const AciAirD4NoticesApiUrls = {
    GET: `${process.env.REACT_APP_USER_ACI_SHARED_URL}/shared/d4Notices/get`,
    POST: `${process.env.REACT_APP_USER_ACI_AIR_URL}/aci-air/d4notice/create`,
  };
  
  export default AciAirD4NoticesApiUrls;
  